import BaseModel from './BaseModel';

export default class ScreeningProgressSummary extends BaseModel {
  constructor(data = {}) {
    super(ScreeningProgressSummary, data);
    this.screenedCount = data.screenedCount;
    this.partiallyScreenedCount = data.partiallyScreenedCount;
    this.conflictedScreenCount = data.conflictedScreenCount;
    this.unscreenedCount = data.unscreenedCount;
    this.userRequiredVoteCount = data.userRequiredVoteCount;
    this.userVoteCount = data.userVoteCount;
    this.userVoteCountToday = data.userVoteCountToday;
  }

  hasScreenedReferences() {
    return this.screenedCount > 0;
  }

  totalReferenceCount() {
    return (
      this.unscreenedCount +
      this.partiallyScreenedCount +
      this.conflictedScreenCount +
      this.screenedCount
    );
  }

  totalRemaining() {
    return (
      this.unscreenedCount +
      this.partiallyScreenedCount +
      this.conflictedScreenCount
    );
  }

  remainingUserCanVoteOnCount() {
    return this.unscreenedCount + this.userRequiredVoteCount;
  }
}
